export enum ServiceStatus {
    None = 0,
    Active = 1,
    Inactive = 2
}
